import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Snackbar from '@material-ui/core/Snackbar'
import Alert from '@material-ui/lab/Alert'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { closeSnackbar } from '../../ducks/snackbar/actions'
import { IStoreState } from '../../store/types'
import { useMediaQuery } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}))

export const CustomizedSnackbars = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const snackbar = useSelector((state: IStoreState) => state.snackbar)
  const { isOpen, message, time, severity } = snackbar

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }

    dispatch(closeSnackbar())
  }

  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{
          vertical: isMobile ? 'top' : 'bottom',
          horizontal: 'center',
        }}
        open={isOpen}
        autoHideDuration={time}
        onClose={handleClose}
      >
        <Alert elevation={6} variant="filled" onClose={handleClose} color={severity}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  )
}
